import { FC } from 'react';

import { MpOl } from 'shared/ui/MpOl';
import { MpParagraph } from 'shared/ui/MpParagraph';
import { MpPropertyTitle } from 'shared/ui/MpPropertyTitle';
import { MpText } from 'shared/ui/MpText';
import { ImgStyled } from './SpurtInstructions.styles';

export type ApplicationInstructionProps = {
	applicationId: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SpurtInstructions: FC<ApplicationInstructionProps> = () => (
	<>
		<MpPropertyTitle>Как подключить бота</MpPropertyTitle>
		<MpOl style={{ gap: `12px` }}>
			<li>
				<MpText>Оформите подписку Premium в маркетплейсе</MpText>
			</li>
			<li>
				<MpText>После оформления подписки нажмите кнопку «Начать пользоваться»</MpText>
			</li>
			<li>
				<MpText>Выдайте разрешение на доступ к вашим данным</MpText>
			</li>
			<li>
				<MpText>Перейдите к боту в Телеграм</MpText>
			</li>
			<li>
				<MpText>Нажмите кнопку «Старт», а затем «Начать работу»</MpText>
			</li>
		</MpOl>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/spurt/instruction-gif' />
		<MpParagraph>
			С подробной инструкцией по работе с ботом можно ознакомиться{` `}
			<a href='https://doc.clickup.com/2699605/p/h/2jcan-15504/c4ed123ab77c69e' rel='noreferrer' target='_blank'>
				здесь
			</a>
			.
		</MpParagraph>
	</>
);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SpurtInstructions_eng: FC<ApplicationInstructionProps> = () => (
	<>
		<MpPropertyTitle>How to Connect the Bot</MpPropertyTitle>
		<MpOl style={{ gap: `12px` }}>
			<li>
				<MpText>Subscribe to Premium in the marketplace</MpText>
			</li>
			<li>
				<MpText>After subscribing, click the &quot;Start Using&quot; button</MpText>
			</li>
			<li>
				<MpText>Grant permission to access your data</MpText>
			</li>
			<li>
				<MpText>Go to the bot on Telegram</MpText>
			</li>
			<li>
				<MpText>Click the &quot;Start&quot; button, and then &quot;Begin Work&quot;</MpText>
			</li>
		</MpOl>
		<ImgStyled src='https://cdn.dodostatic.net/static/marketplace/spurt/instruction-gif' />
		<MpParagraph>
			For a detailed guide on using the bot, you can familiarize yourself{` `}
			<a href='https://doc.clickup.com/2699605/p/h/2jcan-15504/c4ed123ab77c69e' rel='noreferrer' target='_blank'>
				here
			</a>
			.
		</MpParagraph>
	</>
);
